import React, { useRef, useState } from "react"
import Box from "@mui/material/Box"
import styles from "./Layout.module.scss"
import sidemenuButton from "../../assets/images/sidemenu_shortcut.png"
import unread_bell from "../../assets/images/unread_bell.svg"
import LogoutIcon from "../../assets/images/logout_black_icon.svg"
import back_button from "../../assets/images/back_page.svg"
import bell from "../../assets/images/bell.png"
import useGetDeviceType from "../../hooks/useGetDeviceType"
import NotificationPanel from "../../pages/Notifications/features/NotificationPanel"
import { useSidemenuContext } from "../../pages/Sidemenu/SidemenuContextprovider"
import { useSelector } from "react-redux"
import comment_icon from "../../assets/images/chat.svg"
import useOutsideElementAlerter from "../../hooks/useOutsideElementAlerter"
import { useNavigate, useLocation } from "react-router-dom"
import ToolTip from "../ToolTip/ToolTip"
import TagsPopover from "../TagsPopover"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTimer } from "@fortawesome/pro-solid-svg-icons"

type LayoutProps = {
    children: JSX.Element
    heading: any
    subHeading: any
    navigateMainPage?: any
    subHeadingClickable?: any
    handleComment?: any
    commentAccess?: boolean
    dealType?: string
    ticketId?: number
    moduleId?: number
    subModuleId?: number
    backButton?: boolean
    backButtonClick?: any
    showTagsComponent?: boolean
    module_name?: string
    primaryTag?: any
    selectedTags?: any[]
    TagsLoading?: boolean
    ticket_type?: string
    tagAccess?: any
}

type BannerConfig = { route: string; message: string }

const BANNERS: BannerConfig[] = (() => {
    try {
        return JSON.parse(process.env.REACT_APP_BANNER || "[]")
    } catch {
        return []
    }
})()

function Layout(props: LayoutProps) {
    const { deviceType } = useGetDeviceType()
    const navigate = useNavigate()
    const location = useLocation()

    const activeBanner = BANNERS.find(b => location.pathname?.toLowerCase().startsWith(b.route))
    const wrapperRef = useRef(null)
    const logoutRef = useRef<HTMLDivElement | null>(null)
    const [show, setShow] = useState(false)
    const [showLogout, setShowLogout] = useState(false)
    const { handleSideToggle } = useSidemenuContext()
    const { user_initials, user_colour } = useSelector((store: any) => store.verifyLogin.loginData.user_data)
    const notification = useSelector((store: any) => store.notification)
    const logout = () => {
        window.location.href = "/auth"
    }

    useOutsideElementAlerter(wrapperRef, setShow, "notification")
    useOutsideElementAlerter(logoutRef, setShowLogout, "logout")

    return (
        <Box display={"flex"} flexDirection={"column"} width={"100%"}>
            {activeBanner && (
                <Box
                    bgcolor="#FC5735"
                    color="#fff"
                    px={2}
                    py={"4px"}
                    fontSize={14}
                    fontWeight={500}
                    overflow="hidden"
                    whiteSpace="nowrap"
                >
                    <Box
                        sx={{
                            display: "inline-flex",
                            gap: "8px",
                            alignItems: "center",
                            willChange: "transform",
                            animation: "marquee 25s linear infinite",
                            "@keyframes marquee": {
                                "0%": { transform: "translateX(100vw)" },
                                "100%": { transform: "translateX(-100%)" },
                            },
                        }}
                    >
                        <FontAwesomeIcon icon={faTimer} />
                        <Box component="span">{activeBanner.message}</Box>
                    </Box>
                </Box>
            )}
            <div className={styles.layoutV2_container}>
                <>
                    <div className={styles.layoutV2_container_header}>
                        <div className={styles.layoutV2_container_header_left} style={{ width: "70%" }}>
                            {deviceType === "Mobile" ? (
                                <div style={{ position: "relative" }}>
                                    <img
                                        className={styles.layoutV2_container_sidemenuButton}
                                        src={sidemenuButton}
                                        alt="sidemenuButton"
                                        onClick={handleSideToggle}
                                    />
                                    <div
                                        style={{
                                            position: "absolute",
                                            top: "-23px",
                                            width: "100vw",
                                            overflow: "hidden",
                                        }}>
                                        <NotificationPanel wrapperRef={wrapperRef} isShown={show} />
                                    </div>
                                </div>
                            ) : (
                                ""
                            )}
                            <div>
                                <span className={styles.heading_container}>
                                    {props.backButton ? (
                                        <div className="flex-center">
                                            <ToolTip
                                                containerClass={styles.tooltip_container}
                                                data={"Back"}
                                                width={"60px"}
                                                tooltipPadding="8px"
                                                spaceFromLeft="45px"
                                                trigger={
                                                    <img
                                                        src={back_button}
                                                        alt="backButton"
                                                        style={{ marginRight: 10 }}
                                                        onClick={() => navigate(props.backButtonClick)}
                                                    />
                                                }
                                            />
                                            <span className={styles.layoutV2_container_heading}>{props.heading}</span>
                                        </div>
                                    ) : (
                                        <div className="flex-center">
                                            <p className="layoutV2_container_sub_heading">
                                                {props.subHeadingClickable !== undefined && (
                                                    <div className="flex-center">
                                                        <ToolTip
                                                            containerClass={styles.tooltip_container}
                                                            data={"Back"}
                                                            width={"60px"}
                                                            tooltipPadding="8px"
                                                            spaceFromLeft="45px"
                                                            trigger={
                                                                <img
                                                                    src={back_button}
                                                                    alt="backButton"
                                                                    style={{ marginRight: 10 }}
                                                                    onClick={() => props.navigateMainPage()}
                                                                />
                                                            }
                                                        />
                                                    </div>
                                                )}
                                            </p>
                                            <span className={styles.layoutV2_container_heading}>{props.heading}</span>
                                        </div>
                                    )}
                                    {props?.dealType && (
                                        <span className={styles.dealType_container}>
                                            {props?.dealType
                                                ? props?.dealType.replace("Cpo", "CPO").replace("Infra", "Infra (EPC)")
                                                : props?.dealType}
                                        </span>
                                    )}
                                </span>
                            </div>
                        </div>
                        <div className={styles.layoutV2_container_header_right}>
                            {props.navigateMainPage && props?.commentAccess ? (
                                <div>
                                    <img
                                        src={comment_icon}
                                        alt="comment_icon"
                                        className={styles.notification_icon}
                                        onClick={(event: any) => props.handleComment()}
                                    />
                                </div>
                            ) : null}
                            <div style={{ position: "relative" }}>
                                <img
                                    id="notification"
                                    className={styles.notification_icon}
                                    src={notification?.notifications?.is_unread ? unread_bell : bell}
                                    alt="bell"
                                    onClick={() => {
                                        setShow(!show)
                                    }}
                                />
                                <div
                                    className={styles.notification_cont}
                                    style={deviceType === "Mobile" ? { right: "-25px", top: "-12px" } : {}}>
                                    <NotificationPanel wrapperRef={wrapperRef} isShown={show} />
                                </div>
                            </div>
                            {user_initials && (
                                <div
                                    style={{ backgroundColor: `${user_colour}` }}
                                    id="logout"
                                    className={styles.user_initial}
                                    onClick={() => {
                                        setShowLogout(!showLogout)
                                    }}>
                                    {user_initials}
                                </div>
                            )}
                            {showLogout && (
                                <div ref={logoutRef} className={styles.logout_tooltip} id="logout">
                                    <div className={styles.logout_container__inner} onClick={() => logout()}>
                                        <span className={styles.logout_text}>Logout</span>
                                        <span className={styles.logout_icon}>
                                            <img src={LogoutIcon} alt="Logout" />
                                        </span>
                                    </div>
                                    <span className={styles.name}>
                                        Crystalina {process.env.REACT_APP_VERSION || "v18.0.0"}
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                    {props?.showTagsComponent ? (
                        props?.TagsLoading ? (
                            <div>Loading Tags....</div>
                        ) : (
                            <div className="h-5 mt-8 ml-30">
                                <TagsPopover
                                    dealDetailDisplay={true}
                                    ticket_id={props?.ticketId}
                                    primaryTag={props?.primaryTag}
                                    selectedTags={props?.selectedTags}
                                    module_name={props?.module_name}
                                    ticket_type={props.ticket_type}
                                    tagAccess={props?.tagAccess}
                                />
                            </div>
                        )
                    ) : (
                        <></>
                    )}
                </>
                <div id="layout_container" className={styles.layoutV2_container_list_container}>
                    {props.children}
                </div>
            </div>
        </Box>
    )
}

export default Layout
